import { Observable } from 'rxjs';
import persistConfig from 'store/persistConfig';
import store from 'store/configureStore';
import { logout } from '../actions/logout';


Observable
  .fromEvent(window, 'storage')
  .subscribe(({ key, oldValue, newValue }) => {
    const persist = localStorage.getItem(`persist:${ persistConfig.key }`);
    let currentSessionStatus = null;
    try {
      currentSessionStatus = JSON.parse(JSON.parse(persist).session).sessionInfo.sessionId;
    } catch (e) {}

    if (key === `persist:${ persistConfig.key }`) {
      const prevSessionStatus = JSON.parse(JSON.parse(oldValue).session).sessionInfo.sessionId;

      if (!prevSessionStatus && currentSessionStatus) {
        window.location.reload();
      }
    }

    if ((currentSessionStatus && !key) || (key === 'jwt' && oldValue && !newValue)) {
      return store.dispatch(logout(true));
    }
  });
